import React from "react";
import Icons from "./Icons";
import { PLACEHOLDER_TEXT } from "./constants";

const SkillsSection = ({ section, location, updateSection }) => {
  const getPlaceholder = () => {
    switch (section.type) {
      case "languages":
        return "e.g., English";
      case "technical":
        return "e.g., JavaScript, Python, React";
      case "interests":
        return "e.g., Photography, Hiking";
      case "competencies":
      default:
        return "e.g., Project Management";
    }
  };

  const getLabel = () => {
    switch (section.type) {
      case "languages":
        return "Languages & Proficiency";
      case "technical":
        return "Technical Skills";
      case "interests":
        return "Personal Interests";
      case "competencies":
      default:
        return "Core Skills & Competencies";
    }
  };

  const getHint = () => {
    switch (section.type) {
      case "languages":
        return "Add languages you speak and your proficiency level";
      case "technical":
        return "List programming languages, frameworks, tools, and technologies";
      case "interests":
        return "Share hobbies and interests that showcase your personality";
      case "competencies":
      default:
        return "Add professional skills like leadership, communication, analysis, etc.";
    }
  };

  const addItem = () => {
    const newItem =
      section.type === "languages" ? { name: "", proficiency: "" } : "";
    updateSection(location, section.id, {
      items: [...(section.items || []), newItem],
    });
  };

  const updateItem = (index, value, field = null) => {
    const newItems = [...section.items];
    if (section.type === "languages" && field) {
      newItems[index] = { ...newItems[index], [field]: value };
    } else {
      newItems[index] = value;
    }
    updateSection(location, section.id, { items: newItems });
  };

  const removeItem = (index) => {
    const newItems = section.items.filter((_, i) => i !== index);
    updateSection(location, section.id, { items: newItems });
  };

  return (
    <div className="skills-section">
      <label className="form-label">
        {getLabel()}
        <span className="label-hint">{getHint()}</span>
      </label>

      <div className="skills-list">
        {section.items?.map((item, idx) => (
          <div key={idx} className="skill-item">
            <input
              type="text"
              value={typeof item === "string" ? item : item.name || ""}
              onChange={(e) => {
                if (section.type === "languages") {
                  updateItem(idx, e.target.value, "name");
                } else {
                  updateItem(idx, e.target.value);
                }
              }}
              className="form-input flex-1"
              placeholder={getPlaceholder()}
            />

            {section.type === "languages" && (
              <input
                type="text"
                value={item.proficiency || ""}
                onChange={(e) => updateItem(idx, e.target.value, "proficiency")}
                className="form-input proficiency-input"
                placeholder="e.g., Native"
              />
            )}

            <button
              onClick={() => removeItem(idx)}
              className="skill-remove-button"
              title="Remove item"
            >
              <Icons.X className="w-4 h-4" />
            </button>
          </div>
        ))}
      </div>

      <button onClick={addItem} className="add-skill-button">
        <Icons.Plus className="w-4 h-4" />
        Add{" "}
        {section.type === "competencies"
          ? "Skill"
          : section.type === "languages"
          ? "Language"
          : section.type === "technical"
          ? "Technical Skill"
          : "Interest"}
      </button>

      {section.items?.length === 0 && (
        <p className="empty-message">
          No {section.type === "languages" ? "languages" : "skills"} added yet.
          Start adding to showcase your abilities.
        </p>
      )}

      {section.type === "competencies" && section.items?.length > 0 && (
        <p className="skills-tip">
          💡 Tip: Order your skills by relevance to your target role, with the
          most important ones first.
        </p>
      )}
    </div>
  );
};

export default SkillsSection;
